var _rect, _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.102661,
    y: 0.712646,
    width: 59.0927,
    height: 59.0927,
    rx: 17.3802,
    fill: "#C17B31"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_234_14)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.7908 20.2761H34.4709C35.4275 20.2761 36.204 21.0521 36.204 22.0083C36.204 22.9644 35.4275 23.7405 34.4709 23.7405H13.7908C12.8341 23.7405 12.0577 22.9644 12.0577 22.0083C12.0577 21.0521 12.8341 20.2761 13.7908 20.2761Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_14",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 12,
    width: 16,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6199 31.5325V12.8789H47.5331V31.5325H32.6199Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7903 13.0383C34.0088 13.0383 34.2241 13.0992 34.4145 13.2177L46.7999 21.0181C47.1401 21.2334 47.3477 21.6062 47.3477 22.0085C47.3477 22.411 47.1401 22.7838 46.7999 22.999L34.4145 30.7994C34.054 31.0256 33.5983 31.0397 33.2253 30.8322C32.8508 30.6263 32.6198 30.2348 32.6198 29.809V14.2082C32.6198 13.7823 32.8508 13.3908 33.2253 13.1849C33.4016 13.0867 33.5968 13.0383 33.7903 13.0383Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45.5682 40.7385H24.8882C23.9314 40.7385 23.155 39.9625 23.155 39.0064C23.155 38.0501 23.9314 37.2742 24.8882 37.2742H45.5682C46.5249 37.2742 47.3014 38.0501 47.3014 39.0064C47.3014 39.9625 46.5249 40.7385 45.5682 40.7385Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_234_14",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 29,
    width: 16,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6212 29.4822V48.1357H11.7079V29.4822H26.6212Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_234_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4506 47.9764C25.2321 47.9764 25.0168 47.9156 24.8264 47.7971L12.441 39.9967C12.1008 39.7814 11.8932 39.4086 11.8932 39.0062C11.8932 38.6038 12.1008 38.231 12.441 38.0158L24.8264 30.2154C25.1869 29.9892 25.6426 29.9752 26.0155 30.1826C26.3901 30.3885 26.6211 30.78 26.6211 31.2058V46.8067C26.6211 47.2324 26.3901 47.6239 26.0155 47.8298C25.8392 47.9281 25.6441 47.9764 25.4506 47.9764Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4985,
    height: 35.6294,
    fill: "white",
    transform: "translate(11.3996 12.8789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentProcessing);
export default __webpack_public_path__ + "static/media/payment_processing.e6caa9b4bde2c62046ef1c311683f746.svg";
export { ForwardRef as ReactComponent };